var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"visual"},[_c('router-view'),_c('Preloader'),_c('Pinchzoom'),_c('Tooltip'),_c('Panel')],1)}
var staticRenderFns = []

export { render, staticRenderFns }